import InlineStyled from '../InlineStyled/InlineStyled';

const AppCard2 = ({ children, width = '100%', className = '' }) => {
  return (
    <InlineStyled
      className={className}
      $style={{
        padding: 24,
        borderRadius: 12,
        border: '1px solid rgba(0, 0, 0, 0.10)',
        background: '#fff',
        width,
      }}
    >
      {children}
    </InlineStyled>
  );
};

export default AppCard2;
